export const __timestamps_schema = {
  root: "timestamps",
  created_on: "timestamps.created_on",
  updated_on: "timestamps.updated_on",
  deleted_on: "timestamps.deleted_on",
  last_active_on: "timestamps.last_active_on",
};
